module.exports = __webpack_public_path__ + "img/3.cf69bae0.png";